import { render } from "./ProductToPriceGroups.vue?vue&type=template&id=0b63a8fc&ts=true"
import script from "./ProductToPriceGroups.vue?vue&type=script&lang=ts"
export * from "./ProductToPriceGroups.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__